import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IInfoModalData } from './models/infoModalData';

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['info-modal.component.scss'],
    standalone: false
})
export class InfoModalComponent {

	public config: IInfoModalData<InfoModalComponent>;

	constructor(
		private dialogRef: MatDialogRef<InfoModalComponent>,
		@Inject(MAT_DIALOG_DATA) private data: IInfoModalData<InfoModalComponent>
	) {
		this.config = { ...this.data };
	}

	close(): void {
		this.dialogRef.close();
	}

	primaryAction(): void {
		this.config.primaryButtonCallback(this.dialogRef);
	}

	secondaryAction(): void {
		this.config.secondaryButtonCallback(this.dialogRef);
	}
}
